import axios from 'axios';

// Define your base URL and credentials
export const baseUrl = 'https://cp-bzg-082.chili-publish.online/';
export const username = 'enduser';
export const password = '4iXyMHTdxzYccp3a';

// Function to set an item in local storage with the provided expiry timestamp
export function setItemWithExpiryFromApi(key, value, expiryTimestamp) {
  const item = {
    value: value,
    expiry: expiryTimestamp, // Use the expiry timestamp provided by the API
  };
  localStorage.setItem(key, JSON.stringify(item));
}

// Function to get an item from local storage and check expiration
export function getItemWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null; // Key doesn't exist
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  // If the item has expired, remove it and return null
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value; // Return valid value
}

// Function to fetch a new API key from the API
export async function fetchNewApiKey() {
  try {
    const response = await axios.post(`${baseUrl}rest-api/v1/system/apikey?environmentNameOrURL=cp-bzg-082`, {
        username: username,
        password: password,
    },
    {
      headers: {
        Accept: 'application/xml',
      },
    });

    // Parse the XML response
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(response.data, 'text/xml');    

    // Extract the API key and expiry from the XML response
    const apiKey = xmlDoc.getElementsByTagName('apiKey')[0].getAttribute('key');
    const validTill = xmlDoc.getElementsByTagName('apiKey')[0].getAttribute('validTill');
    const expiryTimestamp = new Date(validTill).getTime(); // Convert expiry date to a timestamp

    return { apiKey, expiryTimestamp };
  } catch (error) {
    console.error('Error fetching new API key:', error.message);
    throw error;
  }
}

// Function to get API key from local storage or fetch a new one
export async function getApiKeyWithStorage(storageKey) {
  // Check local storage for an existing valid API key
  let apiKey = getItemWithExpiry(storageKey);

  if (!apiKey) {
    console.log('No valid API key found. Fetching a new one...');
    const { apiKey: newApiKey, expiryTimestamp } = await fetchNewApiKey();

    console.log(newApiKey);

    // Store the new API key with the expiry timestamp provided by the API
    setItemWithExpiryFromApi(storageKey, newApiKey, expiryTimestamp);
    apiKey = newApiKey;
  }

  return apiKey; // Return the valid or newly fetched API key
}
